<template>
  <span v-if="!device.online && device.first_activation && device.last_online">
    {{ device.last_online | dayjs('DD.MM.YYYY, HH:mm') }}
    {{ $t('timeOfDay') }}
  </span>
</template>

<script>
export default {
  props: {
    device: {
      type: Object,
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Device/DeviceLastOnline.vue